var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['z-line-wrapper', _vm.vertical && 'vertical', _vm.reverse && 'reverse', _vm.labelVerticalAlign && `label-v-${_vm.labelVerticalAlign}`, _vm.list && 'list'],style:(_vm.newStyle)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }